module.exports = __webpack_public_path__ + "static/img/product-Data-Service-img-768x592.7f3e96ce.png";